import { render, staticRenderFns } from "./AdsType26.vue?vue&type=template&id=2b20e43e&scoped=true&lang=html&"
import script from "./AdsType26.vue?vue&type=script&lang=js&"
export * from "./AdsType26.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AdsType26.vue?vue&type=style&index=0&id=2b20e43e&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2b20e43e",
  null
  ,true
)

export default component.exports